import React from 'react';
import DefaultLocales from 'globals/locales/default';
import { WrapperBox, Caption, Value } from './TotalIncome.style-elements';

const { totalIncome: totalIncomeLabel } = DefaultLocales;

interface TotalIncomeProps {
  value: string;
}

const TotalIncome: React.FC<TotalIncomeProps> = ({ value }) => {
  return (
    <WrapperBox>
      <Caption>{totalIncomeLabel}:</Caption>
      <Value>{value}</Value>
    </WrapperBox>
  );
};

export default TotalIncome;
